import React from "react";
import { Text } from "react-internationalization";
export const Body = (props) => {
  return (
    <div>
      <p>
      <Text id="header.AboutWebApp1"/>
        <br />
        <span><Text id="header.AboutWebApp2"/></span>
        <br /><Text id="header.AboutWebApp3"/>
      </p>
    </div>
  );
};
